import React from 'react';
import block from 'bem-cn-lite';
import {Spin} from '@yandex-data-ui/common';

import DelayRender from 'components/DelayRender/DelayRender';

import './BlockLoader.scss';

const b = block('BlockLoader');

const BlockLoader: React.FC = () => (
    <DelayRender>
        {() => (
            <div className={b()}>
                <Spin size="xl" />
            </div>
        )}
    </DelayRender>
);

export default BlockLoader;
